/**
 * A running task only auto-scrolls when the host asked for it. Inspecting a
 * live row must not fall through to the "active" scroll, or an agent page
 * with auto-scroll off still jumps.
 */
export function shouldAutoScrollTaskRow({
  isRunning,
  autoScrollOnRunning,
  active,
}: {
  isRunning: boolean;
  autoScrollOnRunning: boolean;
  active: boolean;
}): boolean {
  if (isRunning) return autoScrollOnRunning;
  return active;
}
